"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItemStructureError = exports.ItemState = void 0;
var ItemState;
(function (ItemState) {
    ItemState["published"] = "published";
    ItemState["draft"] = "draft";
    ItemState["archived"] = "archived";
})(ItemState || (exports.ItemState = ItemState = {}));
var ItemStructureError;
(function (ItemStructureError) {
    /** Columns don't match (`columns` should match `positions[{col-x}]`) */
    ItemStructureError["cdm"] = "cdm";
    /** `Positions` and `children` don't match */
    ItemStructureError["pacdm"] = "pacdm";
    /** `Children` missing in `positions` */
    ItemStructureError["cmip"] = "cmip";
    /** `positions` but no `children` */
    ItemStructureError["pbnc"] = "pbnc";
    /** `children` but no `positions` */
    ItemStructureError["cbnp"] = "cbnp";
})(ItemStructureError || (exports.ItemStructureError = ItemStructureError = {}));
